
import { Navigate } from 'react-router-dom';
import { CssBaseline, Box } from '@mui/material';
import Header from '../../ui-component/HeaderNew';
import Sidebar from '../../ui-component/SideBar';
import { Outlet } from 'react-router';
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(isMobile ? false : true);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);


    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Header toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
            <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
            <Box
                component="main"
                sx={{
                    backgroundColor: '#f3f4f8',
                    color: '#18183b',
                    flexGrow: 1,
                    p: 3,
                    mt: 8,
                    minHeight: '100vh',
                    maxHeight: 'auto',
                    transition: 'margin-left 0.3s ease',
                    // marginLeft: sidebarOpen ? '240px' : '0px',
                    overflowX: 'hidden', // Prevent horizontal scroll
                    width: `calc(100% - ${sidebarOpen ? '240px' : '0px'})`, // Adjust dynamically
                }}

            >
                {/* Content goes here */}
                <Outlet />
            </Box>
        </Box>


    );
};

export default MainLayout;
